import type { ReactNode } from 'react';

import ProsopiteErrorNotifier from '@/components/development/prosopite-error-notifier';
import InertiaMetaTags from '@/components/inertia-meta-tags';
import {
  CustomFooterScripts,
  CustomHeaderScripts,
} from '@/components/page-sections/custom-scripts';
import { CookieBanner } from '@/components/public/cookie-banner';
import { GoogleAnalyticsTracking } from '@/components/public/google-analytics-tracking';
import { SiteFontLinks } from '@/components/shared/site-font-links';
import { Toaster } from '@/components/ui/toast';
import { usePublicDesignSettings } from '@/hooks/use-public-design-settings';

export default function PublicLayout({ children }: { children: ReactNode }) {
  const { buttons, fonts, themeVariables } = usePublicDesignSettings();

  return (
    <>
      <InertiaMetaTags />
      <SiteFontLinks fonts={fonts} />
      <GoogleAnalyticsTracking />
      <CustomHeaderScripts />
      <div
        id="public-layout"
        data-theme-root
        data-site-button-shape={buttons?.shape}
        data-site-button-style={buttons?.style}
        className="bg-background text-foreground"
        style={themeVariables}
      >
        <Toaster />
        <ProsopiteErrorNotifier />
        {children}
        <CookieBanner />
      </div>
      <CustomFooterScripts />
    </>
  );
}
